/**
 * InventoryTagItemSpan.jsx
 * Created by Destin Frasier on 12/28/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    name: PropTypes.string.isRequired,
    icon: PropTypes.node.isRequired,
    iconClass: PropTypes.string.isRequired,
    gray: PropTypes.bool
};

const defaultProps = {
    gray: false
};

const InventoryTagItemSpan = ({ name, icon, iconClass, gray }) => (
    <span className={`rec-${iconClass}-tag ${gray ? 'alt' : ''}`} key={name} title={name}>
        {icon}
    </span>
);

InventoryTagItemSpan.propTypes = propTypes;
InventoryTagItemSpan.defaultProps = defaultProps;

export default InventoryTagItemSpan;
